import { useRef, useState } from "react";
import { Navigate } from "react-router-dom";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useBranding, loadBranding } from "@/lib/branding";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { PageHeader } from "@/components/StatusBadge";
import { BrandMark } from "@/components/layout/Ambient";

export default function Branding() {
  const { meta } = useAuth();
  const b = useBranding();
  const [f, setF] = useState({ name: b.name, tagline: b.tagline });
  const [busy, setBusy] = useState(false);
  const ref = useRef(null);
  if (!meta.permissions.manage_users) return <Navigate to="/dashboard" replace />;
  const save = async () => { try { await api.put("/branding", f); await loadBranding(); toast.success("Branding saved"); } catch (e) { toast.error(errMsg(e)); } };
  const upload = async (file) => {
    const fd = new FormData(); fd.append("file", file); setBusy(true);
    try { await api.post("/branding/logo", fd); await loadBranding(); toast.success("Logo updated"); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="max-w-2xl">
      <PageHeader eyebrow="Governance" title="Organisation branding" testid="branding-title" />
      <div className="rounded-lg bg-white border glow-border p-6 space-y-6">
        <div className="flex items-center gap-5">
          <BrandMark size="w-20 h-20" testid="branding-logo-preview" />
          <div className="space-y-2">
            <input ref={ref} type="file" accept="image/png,image/jpeg,image/webp,image/svg+xml" className="hidden" onChange={(e) => e.target.files[0] && upload(e.target.files[0])} data-testid="branding-logo-input" />
            <Button variant="outline" onClick={() => ref.current.click()} disabled={busy} data-testid="branding-logo-upload-button">{busy ? <Loader2 className="w-4 h-4 animate-spin mr-1.5" /> : <Upload className="w-4 h-4 mr-1.5" />}Upload official logo</Button>
            <p className="text-xs text-slate-500">PNG, JPG, WEBP or SVG, under 3 MB. Shown on the sidebar, login page, dashboard, cover sheets and reports.</p>
          </div>
        </div>
        <div className="space-y-1.5"><Label className="text-xs">Organisation name</Label><Input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="branding-name-input" /></div>
        <div className="space-y-1.5"><Label className="text-xs">Tagline</Label><Input value={f.tagline} onChange={(e) => setF({ ...f, tagline: e.target.value })} data-testid="branding-tagline-input" /></div>
        <Button onClick={save} data-testid="branding-save-button">Save branding</Button>
      </div>
    </div>
  );
}
